<template>
    <ul class="line-list clearBoth">
        <li :key="'i' + index" v-for="(item, index) in list">
            <p @click="selectLine(item)" class="name" :class="{active: item.selected}" :style="{backgroundColor: item.selected ? activeColor : ''}">{{item.title}}</p>
            <div class="block">
                <p class="v">
                    <span>{{item.v || 'xx'}}</span>
                    <br/>
                    <span class="t">毫秒</span>
                </p>
            </div>
        </li>
    </ul>
</template>

<script>
  export default {
    name: "line-list",
    props: {
      list: {
        type: Array,
        default () {
          return [
            {
              title: '线路1',
              v: 46,
              selected: true
            },
            {
              title: '线路2',
              v: 46
            },
            {
              title: '线路3',
              v: 46
            },
            {
              title: '线路4',
              v: 46
            },
            {
              title: '线路5',
              v: 46
            },
            {
              title: '线路6',
              v: 46
            },
            {
              title: '线路7',
              v: 46
            },
          ];
        }
      },
      activeColor: {
        type: String,
        default: '#E64520'
      }
    },
    methods: {
      selectLine (item) {
        if (item.selected) return;

        this.list.forEach(line => {
          line.selected = false;
        });
        item.selected = true;


        this.$emit('onSelectLine', item);
      }
    },
  }
</script>

<style scoped lang="stylus">
    .line-list
        color #fff
        padding 20px
        font-size 15px
        text-align center
        >li{
            width 120px
            float left
            .name{
                cursor pointer
                height 38px
                border 1px solid #ffffff
                text-align center
                background rgba(255,255,255,0.2)
                border-radius 20px
                line-height 38px
                &.active{
                    border-color transparent
                }
            }
            .block{
                width 120px
                height 120px
                margin-top 10px
                border-radius 10px
                background rgba(255,255,255,0.2)
                &:after{
                    width 0
                    height 100%
                    display inline-block
                    content ""
                    vertical-align middle
                }
                .v {
                    color #fff;
                    display inline-block
                    text-align center
                    font-weight bold
                    vertical-align middle
                    span {
                        display block
                        font-size 26px
                    }
                    .t {
                        font-size 14px
                        margin-top 5px
                        font-weight normal
                    }
                }
            }
        }
        >li+li{
            margin-left 20px
        }
</style>


// WEBPACK FOOTER //
// src/pages/line/components/line-conponent/list.vue